module.exports = __webpack_public_path__ + "assets/img/chef-12.2bb27a2f.jpg";